const initialState = window.__STATE__.csrfSymfony || {};

export default function reducer(state = initialState, action) {
  return state
}
